document.documentElement.classList.add('js');
document.querySelectorAll('.im8-cc__row,.im8-launch__animate').forEach(element=>element.classList.add('is-visible'));
document.querySelectorAll('.im8-body-support__content').forEach((element,index)=>element.classList.toggle('is-active',index===0));
document.querySelectorAll('.instant-native-offer').forEach(offer=>{
  const form=offer.closest('.product__info-wrapper')?.querySelector('form[action*="/cart/add"]');
  if(!form)return;
  const variantInput=form.querySelector('input[name="id"]');
  let sellingPlanInput=form.querySelector('input[name="selling_plan"]');
  offer.addEventListener('change',event=>{
    const choice=event.target.closest('input[name="instant_offer"]');
    if(!choice)return;
    offer.querySelectorAll('.instant-native-offer__option').forEach(label=>label.classList.toggle('is-selected',label.contains(choice)));
    if(variantInput)variantInput.value=choice.dataset.variantId;
    if(choice.dataset.sellingPlan){
      if(!sellingPlanInput){sellingPlanInput=document.createElement('input');sellingPlanInput.type='hidden';sellingPlanInput.name='selling_plan';form.appendChild(sellingPlanInput);}
      sellingPlanInput.value=choice.dataset.sellingPlan;
    }else if(sellingPlanInput){sellingPlanInput.remove();sellingPlanInput=null;}
  });
});
document.addEventListener('click',event=>{
  const thumbnail=event.target.closest('.thumbnail');
  if(thumbnail){
    const source=thumbnail.querySelector('img');
    const main=document.querySelector('.product__media-list .product__media-item img');
    if(source&&main){main.src=source.src;main.alt=source.alt;document.querySelectorAll('.thumbnail').forEach(item=>item.removeAttribute('aria-current'));thumbnail.setAttribute('aria-current','true');}
  }
  const faq=event.target.closest('.Index_faq_accordion_lists_innerloop_title_new');
  if(faq){const row=faq.closest('.Index_faq_accordion_lists_innerloop_new');row?.classList.toggle('active');}
  const expert=event.target.closest('[data-sab-trigger]');
  if(expert){const key=expert.getAttribute('data-sab-trigger');document.querySelector(`[data-sab-popup="${key}"]`)?.classList.add('is-active');document.querySelector('.im8-pro-sab__overlay')?.classList.add('is-active');}
  if(event.target.closest('[data-sab-close]')||event.target.closest('.im8-pro-sab__overlay')){document.querySelectorAll('.im8-pro-sab__popup,.im8-pro-sab__overlay').forEach(item=>item.classList.remove('is-active'));}
});